import { CUSTOM_ELEMENTS_SCHEMA, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { NavigateTo } from '@ngdock/router';
import { Observable } from 'rxjs';

import { distinctUntilChanged, filter, map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators';
import { AccountingService } from 'src/app/accounting/accounting.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { MembershipService } from 'src/app/membership/membership.service';
import { PageTitleService } from 'src/app/util/page-title.service';
import { AnimatedIconColors } from 'src/app/utils/stylings';
import { TransactionDetailsDestination } from '../../accounting/accounting.destination';
import { AccountingUIService } from '../../accounting/accouting-ui.service';
import { TaxInfoService } from '../../payroll/tax-info.service';
import { showSuccesModal } from '../../utils/modal-utils';
import { DashboardFacade } from './dashboard.facade';
import { getRange, Range, Timeframe } from './dashboard.util';
import { PostLoadDestination } from 'src/app/work/work.destinations';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { ContractorPaymentRecorded } from 'src/app/accounting/state/accounting.actions';
import { FlatpickrDirective, FlatpickrModule } from 'angularx-flatpickr';
import { FlatPickrOutputOptions } from 'angularx-flatpickr/lib/flatpickr.directive';
import flatpickr from 'flatpickr';
import { TranslateModule } from '@ngx-translate/core';
import { TopExpensesComponent } from '../../accounting/widget/top-expenses/top-expenses.component';
import { TransactionTableComponent } from '../../accounting/transaction-table/transaction-table.component';
import { StatWidgetComponent } from '../../accounting/widget/stat-widget/analatics-stat.component';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { NgIf, AsyncPipe, DatePipe } from '@angular/common';


@Component({
    selector: 'app-analytics',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, FlatpickrModule, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, StatWidgetComponent, RouterLink, TransactionTableComponent, TopExpensesComponent, AsyncPipe, DatePipe, TranslateModule],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

/**
 * Analytics Dashboard Component
 */
export class DashboardComponent implements OnInit, OnDestroy {
    private auth = inject(AuthenticationService);
    private fb = inject(FormBuilder);
    private dashboard = inject(DashboardFacade);
    private taxUi = inject(TaxInfoService);

    currentDate: any = null

    // bread crumb items
    breadCrumbItems!: Array<{}>;

    user$ = this.auth.user$;

    range = this.fb.group({
        date: this.fb.group({
            from: [undefined],
            to: [undefined],
        })
    })

    dates$ = this.range.controls.date.valueChanges.pipe(
        distinctUntilChanged(),
        startWith(this.range.value.date),
        shareReplay(1)
    );

    onRefresh$ = this.dates$.pipe(
        filter((value) => !!value?.from && !!value?.to),
        tap((date) => {
            this.dashboard.updateFilter(date?.from!, date?.to!);
        }),
    ).subscribe()

    restore$ = this.dashboard.filter$.subscribe(date => {
        if (!date) {
            return;
        }

        this.range.patchValue({
            date: date as any
        }, { emitEvent: false })

        this.dashboard.loadAccounting(date?.from!, date?.to!);
    })

    colors = AnimatedIconColors

    transactions$: Observable<any[]> = this.dashboard.transactions$;
    summary$: Observable<any> = this.dashboard.summary$;

    onContractorPayment$ = this.taxUi.onContractorPaymentRecorded$.subscribe(() => {
        this.dashboard.refresh();
    })

    constructor(
        private actions$: Actions,
        private router: Router,
        private accUi: AccountingUIService,
        private title: PageTitleService,
    ) {
        title.setTitle('Dashboard');

        this.dashboard.loadContractors();
    }


    @NavigateTo()
    viewTransaction(transaction: any) {
        return new TransactionDetailsDestination(transaction.id);
    }

    ngOnInit(): void {
        /**
         * BreadCrumb
         */
        this.breadCrumbItems = [
            { label: 'Dashboard', active: true }
        ];
    }

    ngOnDestroy(): void {
        this.onRefresh$.unsubscribe();
        this.restore$.unsubscribe();
        this.onContractorPayment$.unsubscribe();
    }

    toggleActivity() {

    }

    requestActivation() {
        this.auth.requestActivationEmail().subscribe(() => {
            showSuccesModal('Email Activation Sent!');
        })
    }

    private from?: flatpickr.Instance;
    private to?: flatpickr.Instance;

    onReady(field: 'from' | 'to', instance: FlatPickrOutputOptions) {
        if (field === 'from') {
            this.from = instance.instance
        } else {
            this.to = instance.instance
        }
    }

    selectDateRange(time: Timeframe) {
        const range = getRange(time);

        this.from?.set('maxDate', range.to as any)
        this.to?.set('minDate', range.from as any)

        this.range.patchValue({
            date: getRange(time) as any
        })
    }

    async payContractor() {
        try {
            await this.taxUi.addPayment()

            this.dashboard.refresh();
        } catch (error) {

        }
    }

    @NavigateTo(new PostLoadDestination())
    postLoad() { }

    async newTransaction() {
        try {
            await this.accUi.addNewTransaction();

            this.dashboard.refresh();
        } catch (error) {

        }
    }



}
